import { render } from "./ReleaseNotes.vue?vue&type=template&id=f754ad7a&scoped=true"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"

import "./ReleaseNotes.vue?vue&type=style&index=0&id=f754ad7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f754ad7a"]])

export default __exports__